export default __webpack_public_path__ + "static/media/mind.8beb2afc.png";